import { Box, Button, Checkbox, FormControlLabel, Stack } from "@mui/material";
import { PERMISSION_VALUES } from "components/users/permissions";
import { useTenantTranslation } from "hooks/formatters";
import { useAdminPermissions } from "hooks/permissions";

export const PermissionsEditor = () => {
  const { t } = useTenantTranslation();
  const {
    adminPermissions,
    togglePermission,
    enableAllPermissions,
    disableAllPermissions,
  } = useAdminPermissions();
  return (
    <Stack sx={{ flex: "1 1 auto", minHeight: 0 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
          columnGap: 2,
          alignContent: "start",
          flex: "1 1 auto",
          minHeight: 0,
          overflowY: "auto",
        }}
      >
        {PERMISSION_VALUES.map((permission) => (
          <FormControlLabel
            key={permission}
            sx={{ mr: 0 }}
            control={
              <Checkbox
                checked={adminPermissions.includes(permission)}
                onChange={() => {
                  togglePermission(permission);
                }}
              />
            }
            label={permission}
          />
        ))}
      </Box>
      <Stack
        spacing={1}
        sx={{
          flexShrink: 0,
          pt: 1,
          borderTop: 1,
          borderColor: "grey.300",
        }}
      >
        <Stack direction="row" spacing={1}>
          <Button variant="outlined" onClick={enableAllPermissions} fullWidth>
            {t("enableAll")}
          </Button>
          <Button variant="outlined" onClick={disableAllPermissions} fullWidth>
            {t("disableAll")}
          </Button>
        </Stack>
        <Button
          onClick={() => {
            window.location.reload();
          }}
          variant="contained"
        >
          {t("savePermissions")}
        </Button>
      </Stack>
    </Stack>
  );
};
